import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { dataFormStyles } from '~/modules/covenants/CovenantsDataForm/styles.ts';
import { managerComponentStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/components/styles.ts';

interface IManagerRejectCommentsModalProps {
  open: boolean;
  missingCommentsCount: number;
  comment: string;
  errorText: string;
  isSubmitting: boolean;
  onClose: () => void;
  onCommentChange: (value: string) => void;
  onConfirm: () => void;
  title?: string;
  primaryText?: string;
  secondaryText?: string;
  commentLabel?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
}

export const RejectCommentsModal: React.FC<IManagerRejectCommentsModalProps> = ({
  open,
  missingCommentsCount,
  comment,
  errorText,
  isSubmitting,
  onClose,
  onCommentChange,
  onConfirm,
  title = 'Не всі коментарі заповнені',
  primaryText,
  secondaryText = 'Введіть загальний коментар. Він буде встановлений для всіх файлів заявки та замінить наявні коментарі.',
  commentLabel = 'Загальний коментар',
  cancelButtonLabel = 'Відмінити',
  confirmButtonLabel = 'Підтвердити',
}) => (
  <Dialog
    open={open}
    onClose={isSubmitting ? undefined : onClose}
    fullWidth
    maxWidth="sm"
    sx={managerComponentStyles.rejectDialog}
  >
    <DialogTitle sx={managerComponentStyles.rejectTitle}>{title}</DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2" color="text.secondary" sx={managerComponentStyles.rejectPrimary}>
        {primaryText ?? `Не заповнено коментарів: ${missingCommentsCount}.`}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={managerComponentStyles.rejectSecondary}
      >
        {secondaryText}
      </Typography>
      <TextField
        autoFocus
        fullWidth
        multiline
        rows={4}
        label={commentLabel}
        value={comment}
        onChange={(event) => onCommentChange(event.target.value)}
        disabled={isSubmitting}
        error={!!errorText}
        helperText={errorText}
        slotProps={{ htmlInput: { maxLength: 500 } }}
      />
    </DialogContent>
    <DialogActions sx={dataFormStyles.modalActions}>
      <Button onClick={onClose} color="inherit" variant="outlined" disabled={isSubmitting}>
        {cancelButtonLabel}
      </Button>
      <Button variant="contained" onClick={onConfirm} disabled={isSubmitting || !comment.trim()}>
        {confirmButtonLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

